import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NgForOf } from '@angular/common';
import { RouterLink } from '@angular/router';
import { MatTooltip, MatTooltipModule } from '@angular/material/tooltip';

import { RouteHelper } from '@helper/route-paths';
import { Constants } from '@helper/constants';
import { environment } from '../../../../environments/environment';
import { StaticPages } from '@helper/static-pages';

class LinkItem {
  name: string;
  link: string;
  tooltip: string;

  constructor(name: string, link: string, tooltip: string) {
    this.name = name;
    this.link = link;
    this.tooltip = tooltip;
  }
}

@Component({
  selector: 'app-bottom-info-bar',
  templateUrl: './bottom-info-bar.component.html',
  imports: [NgForOf, RouterLink, MatTooltip, MatTooltipModule],
  styleUrls: ['./bottom-info-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BottomInfoBarComponent {
  readonly width = Constants.APP_CONTAINER_WIDTH;
  readonly year = new Date().getFullYear();

  leftItems = [
    new LinkItem($localize`聯絡lativ`, `/${RouteHelper.page(StaticPages.about)}`, ''),
    new LinkItem($localize`購物說明`, `/${RouteHelper.supportService()}`, ''),
    new LinkItem($localize`最新消息`, `/${RouteHelper.page(StaticPages.news)}`, ''),
  ];
  rightItems = [
    new LinkItem($localize`網站使用條款`, `/${RouteHelper.page(StaticPages.terms)}`, ''),
    new LinkItem($localize`隱私權政策`, `/${RouteHelper.page(StaticPages.policy)}`, ''),
    new LinkItem($localize`免責聲明`, `/${RouteHelper.page(StaticPages.disclaimer)}`, ''),
    new LinkItem($localize`© ${this.year} lativ`, '', $localize`版本：${environment.appVersion}`),
  ];
}
